import { render, staticRenderFns } from "./MiniKaskoCoverageSelect.vue?vue&type=template&id=01f72aa6&scoped=true&"
import script from "./MiniKaskoCoverageSelect.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoCoverageSelect.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoCoverageSelect.vue?vue&type=style&index=0&id=01f72aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f72aa6",
  null
  
)

export default component.exports